<template>
  <div class="simple-tab-group" v-show="tabIndex == 1 || tabIndex == 3 || tabIndex == 6">
    <md-card-content>
      <div class="table-header-info">
        <div>
          총 {{ total }} 건의 검색결과가 있습니다.
          <md-button class="md-info md-sm" @click="onClickRow(null, true)" v-if="tabIndex == 1">
            <md-icon>check</md-icon>장학생 매칭
          </md-button>
          <div v-show="tabIndex == 1" style="margin-left: 10px; font-size: 15px; float:right; color:blue; font-weight: bold; vertical-align: middle; line-height: 30px">
            <label>금번학기 지급액 : {{this.amountTot}} | 
          
          누적 약정금액 합계 : {{ this.sumData.totalAgreemAmount.toLocaleString() }}원 |
           누적 실입금액 합계 : {{ this.sumData.totalRealAmount.toLocaleString() }}원 |
            누적 기부금(기본재산) 합계 : {{ this.sumData.totalFundAmount.toLocaleString() }}원</label>

          </div>


        </div>
        <div>
          <select v-model="pagination.perPage" name="pages" @change="perPageChange">
            <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
              {{ item }}
            </option>
          </select>
        </div>
      </div>

      <grid ref="SchaDonorList"
            :data="gridProps.data"
            :columns="gridProps.columns"
            :options="gridProps.options"
            :theme="gridProps.theme"
            :rowHeaders="gridProps.rowHeaders"
            :columnOptions="gridProps.columnOptions"
            :language="gridProps.lang"
            @click="onClickRow"
            @response="response"
      ></grid>

    </md-card-content>
    <md-card-actions md-alignment="right">
      <div>
      </div>
    </md-card-actions>
  </div>
</template>
<script>
import formatter from "@/kuaa/kuaa-formatter";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import session from "@/kuaa/kuaa-sessions";

import Swal from "sweetalert2";
import moment from "moment";


import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';

import tabColumns from "@/pages/Scholarship/Components/gridOptions/DonatorManagementGrid";

export default {
  name: "SchaDonorTab1ListComp",

  props: {
    tabIndex : {
      type: Number,
      default : 1
    },
  sumData: {
    type: Object,
    default: () => ({})
  }
  },

  components: {
    grid: Grid
  },

  created() {
    this.getSemesterCdList();
    this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },
  data() {
    return {
      semesterCd : null,
      memberNo : null,
      gridProps: {},
      pagination: {
        perPage: 200,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },
      amountTot: 10000
    };
  },
  methods: {
    getSemesterCdList (){
      kuaaFnc.fncSemesterCodes(null,res => {
        let semesterCd = res.data.data.contents;
        if(semesterCd.length){
          this.semesterCd = semesterCd[semesterCd.length-1].code;
        }
      });
    },
    sendQuery (index, memberNo, semesterCd){
      this.amountTot = 0;
      this.$refs.SchaDonorList.invoke("refreshLayout");
      if(!index){ //목록 재 검색 등 초기화 해야 하는 경우
        this.$refs.SchaDonorList.invoke("clear");
        this.pagination.total = 0;
        return;
      }
      if(memberNo && memberNo!=this.memberNo){
        this.memberNo = memberNo;
      }
      this.$refs.SchaDonorList.invoke("setColumns", tabColumns['tab'+index]);
      if(index == 1){
        // 최신학기와 교우번호
        this.$refs.SchaDonorList.invoke("readData", 1, {semesterCd: semesterCd ? semesterCd : this.semesterCd, memberNo : this.memberNo, applyMemberNo : null});
      }else if(index == 3){
        // 교우번호
        this.$refs.SchaDonorList.invoke("readData", 1, {semesterCd:null, memberNo : this.memberNo, applyMemberNo : null});
      }else if(index == 6){
        // 교우번호
        this.$refs.SchaDonorList.invoke("readData", 1, {semesterCd:null, memberNo : null, applyMemberNo : this.memberNo});
      }
      this.$refs.SchaDonorList.invoke("refreshLayout");
    },

    initGrid() {
      this.amountTot = 0;
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_SCHA_MAPPING_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.SchaDonorList;
      this.gridProps['columns']= tabColumns.tab1;
      this.gridProps['options'].bodyHeight = 300;
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.SchaDonorList, event, this.pagination);
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
        this.amountTot = res.data.contents.length != 0? formatter.getCurrency(res.data.contents[0].amountTot) + ' 원': '0 원';
        this.$emit('queryCnt', this.pagination.total);
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
      this.$refs.SchaDonorList.invoke("refreshLayout");
    },
    onClickRow(e,isBtn){
      // if(e.nativeEvent.target.className == 'btn-donator-matching' && e.instance.getRow(e.rowKey) != null){
      //   this.$emit('buttonClick', e.instance.getRow(e.rowKey));
      // }
      if(e && e.instance.getRow(e.rowKey) != null) {
        this.$emit('buttonClick',e.instance.getRow(e.rowKey));
      }else if(isBtn){
        this.$emit('buttonClick');
      }
    },
    girdClear(){
      this.$refs.SchaDonorList.invoke("clear");
    }
  }
};
</script>

<style lang="css" scoped>
</style>